// Types
import { SidebarItemsType } from "../../Libs/Types/Sidebar";
// UI-Components
import IconWrapper from "../../UI-Components/IconWraper";

export default function SidebarItem({
  itemName,
  icon,
  selectedItem,
  handleSidebarItemSelection,
}: SidebarItemsType) {
  return (
    <>
      <div
        className={`flex justify-start items-center mx-3 px-2 py-1 rounded-md gap-2 cursor-pointer duration-300 ${
          selectedItem === itemName
            ? "bg-tertiary scale-105 text-primary"
            : "text-secondary hover:bg-hover hover:text-primary hover:scale-105 sideBarItem"
        }`}
        onClick={() => handleSidebarItemSelection(itemName)}
      >
        <IconWrapper
          icon={icon}
          variant={selectedItem === itemName ? "secondary" : "primary"}
          className={` ${
            selectedItem === itemName
              ? "text-icon-secondary"
              : "sidebarIcon text-disable"
          } `}
        />
        <div className="hidden md:block font-normal text-sm">{itemName}</div>
      </div>
    </>
  );
}
